import { FC, useMemo } from 'react'
import { Box, ButtonBase, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'

const HELP_DESK_TABS = [
  {
    value: 'help',
    i18n: { id: 'defectsList.help', defaultMessage: 'Pomoc' }
  },
  {
    value: 'faults',
    i18n: { id: 'defectsList.faults', defaultMessage: 'Usterki' }
  },
  {
    value: 'common-room-reservations',
    i18n: { id: 'defectsList.commonRoomReservationsList', defaultMessage: 'Rezerwacje' }
  }
]

// Tab switcher for the Helpdesk section ("Panel Klienta 3.0").
// Desktop: joined segment buttons with borders. Mobile: segment control.
const HelpdeskTabs: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const location = useLocation()

  const currentTab = useMemo(() => {
    const path = location.pathname.split('/')[1]
    return HELP_DESK_TABS.some(({ value }) => value === path) ? path : 'faults'
  }, [location.pathname])

  if (isDesktop) {
    return (
      <Box sx={{ display: 'inline-flex' }}>
        {HELP_DESK_TABS.map(({ value, i18n }, index) => {
          const isActive = currentTab === value
          return (
            <ButtonBase
              key={value}
              onClick={() => navigate(`/${value}`)}
              sx={{
                width: '154px',
                padding: '11px 20px',
                backgroundColor: isActive ? theme.r4r.navy : '#fff',
                border: `1px solid ${isActive ? theme.r4r.navy : theme.r4r.greyLight}`,
                marginLeft: index === 0 ? 0 : '-1px',
                color: isActive ? '#fff' : theme.r4r.grey,
                fontFamily: theme.typography.fontFamily,
                fontSize: '13px',
                fontWeight: 600,
                lineHeight: '13px',
                whiteSpace: 'nowrap',
                zIndex: isActive ? 1 : 0
              }}>
              {formatMessage(i18n)}
            </ButtonBase>
          )
        })}
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        maxWidth: '320px',
        mx: 'auto',
        backgroundColor: theme.r4r.greyBg,
        padding: '2px'
      }}>
      {HELP_DESK_TABS.map(({ value, i18n }) => {
        const isActive = currentTab === value
        return (
          <ButtonBase
            key={value}
            onClick={() => navigate(`/${value}`)}
            sx={{
              flex: 1,
              padding: '5px 8px',
              backgroundColor: isActive ? theme.r4r.navy : 'transparent',
              boxShadow: isActive ? '0px 0px 5px 0px rgba(0, 0, 0, 0.16)' : 'none'
            }}>
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: 600,
                lineHeight: '22px',
                whiteSpace: 'nowrap',
                color: isActive ? '#fff' : theme.r4r.grey
              }}>
              {formatMessage(i18n)}
            </Typography>
          </ButtonBase>
        )
      })}
    </Box>
  )
}

export default HelpdeskTabs
